<main class="main">
    <div class="container">
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Review Crawled Data</h1>
        </div>
        <div class="card-body">
            <form #filterForm="ngForm" class="navbar-form" class="form-floating">
                <div class="row m-0  searchRecordWrapper">
                    <h4 class="error textError m-0" *ngIf="errorMessage!=null">
                        {{errorMessage}}
                    </h4>
                    <div class="col-3  mt-4">
                        <div class="form-floating">
                            <select class="form-select form-control" id="txtClientMasterId"
                                aria-label="Floating label select example" [(ngModel)]="clientMasterId"
                                [ngModelOptions]="{standalone: true}">
                                <option selected disabled value='null'></option>
                                <option value="{{data?.ClientMasterID}}" *ngFor="let data of clientMasterOptionsList">
                                    {{data?.ClientName}}</option>
                            </select>
                            <label for="txtClientMasterId">Client Master Name</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating">
                            <input type="number" class="form-control" id="txtDocId" min="0" placeholder="MasterSheetID"
                                name="MasterSheetID" [(ngModel)]="pagination.masterSheetId"
                                [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">Master Sheet Id</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating">
                            <input type="number" class="form-control" id="txtDocId" min="0"
                                placeholder="URLConfigurationMasterID" name="URLConfigurationMasterID"
                                [(ngModel)]="pagination.URLConfigurationMasterID" [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">URLConfiguration Master Id</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating mb-3 datePicker">
                            <input type="text" placeholder="Process Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true ,dateInputFormat: 'MM/DD/YYYY'}"
                                [(ngModel)]="ProcessDate" [ngModelOptions]="{standalone: true}" #s1="bsDatepicker"
                                readonly>
                            <label for="txtUrl">Process Date</label>
                            <span class="input-group-text" (click)="s1.toggle()"><i class="fa fa-calendar"></i></span>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex">
                            <button class="btn btn-primary smallBtn" (click)="Search(filterForm)" type="submit"
                                style="height: 47px !important;">Search</button>
                            <!-- <button class="btn btn-primary smallBtn" style="height: 47px !important;"
                                (click)="ExportToXLS()">Export</button> -->
                            <button class="btn btn-default smallBtn" style="height: 47px !important;"
                                (click)="Reset()">Reset</button>

                            <div class="form-check" style = "margin-left: 20px;">
                                <input class="form-check-input" type="checkbox" id="wrapText" name="wrapText"
                                    [(ngModel)]="wrapText" [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label p-0">Wrap Text</label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Source URL Status</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center;min-width: 200px;">
                                    URL Configuration Master ID
                                </th>

                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Mastersheet Id
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Client Name
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    RegLake Status
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Push To CMS
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 150px;">
                                    Is Selenium Required
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Browser Type
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 250px;">
                                    Source URL
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 200px;">
                                    Inclusion Keywords
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 200px;">
                                    Exclusion Keywords
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="reviewCrawledDatalSearchList?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 70px; padding-top: 70px;">
                                    <h6 class="text-center" *ngIf="reviewCrawledDatalSearchList?.length==0" style = "color: red;">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of reviewCrawledDatalSearchList;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td *ngIf="columnList[0].checked" style="width: 10%; text-align:center;" class="ellipsis"
                                    title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}</td>
                                <td *ngIf="columnList[1].checked" style="width:10%; text-align:center;" class="ellipsis"
                                    title="{{data?.MasterSheetId}}">
                                    {{data?.MastersheetId}}
                                </td>
                                <td *ngIf="columnList[2].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.ClientName}}">
                                    {{data?.ClientName}}
                                </td>
                                <td *ngIf="columnList[3].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.RegLakeStatus}}">
                                    {{data?.StatusName}}
                                </td>
                                <td *ngIf="columnList[4].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.PushToCMS}}">
                                    {{data?.PushToCMS}}
                                </td>
                                <td *ngIf="columnList[5].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.IsSeleniumRequired}}">
                                    {{data?.IsSeleniumRequired}}
                                </td>
                                <td *ngIf="columnList[6].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.BrowserType}}">
                                    {{data?.BrowserType}}
                                </td>
                                <td *ngIf="columnList[7].checked" style="width:10%;text-align: center;" class="ellipsis">
                                    <a href="javascript:void(0)" title="{{data?.SourceURL}}"
                                        (click)="NavigateToSourceUrl(data?.ID,data.SourceURL)">{{data?.SourceURL}}</a>
                                </td>
                                <td *ngIf="columnList[8].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.InclusionKeywords}}">
                                    {{data?.InclusionKeywords}}
                                </td>
                                <td *ngIf="columnList[9].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.ExclusionKeywords}}">
                                    {{data?.ExclusionKeywords}}
                                </td>
                            <tr
                                *ngIf="reviewCrawledDatalSearchList?.length<=4 && reviewCrawledDatalSearchList?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- </perfect-scrollbar> -->

                </div>


            </div>

        </div>
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Todays Crawled Data</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Crawled Master Data ID
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 200px;">
                                    Client Name
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    URL Detail ID
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Created On
                                </th>
                                <!-- <th style="width:5%;min-width: 190px;text-align: center;" rowspan="2">Action
                                    </th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="reviewCrawledDatalSearchList1?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 70px; padding-top: 70px;">
                                    <h6 class="text-center" *ngIf="reviewCrawledDatalSearchList1?.length==0" style="color:red">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of reviewCrawledDatalSearchList1;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td *ngIf="columnList1[0].checked" style="width: 10%; text-align:center"
                                    class="ellipsis" title="{{data?.CrawledMasterDataID}}">
                                    {{data?.CrawledMasterDataID}}</td>
                                <td *ngIf="columnList1[1].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.ClientName}}">
                                    {{data?.ClientName}}
                                </td>
                                <td *ngIf="columnList1[2].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.UrlDetailID}}">
                                    {{data?.UrlDetailID}}
                                </td>
                                <td *ngIf="columnList1[3].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY}}">{{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>
                            </tr>
                            <tr
                                *ngIf="reviewCrawledDatalSearchList1?.length<=4 && reviewCrawledDatalSearchList1?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- </perfect-scrollbar> -->

                </div>
            </div>
        </div>
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Todays Processed Record Status</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center;min-width: 130px;">
                                    Crawled JSON ID
                                </th>

                                <th style="width: 5%; text-align: center;min-width: 200px;">
                                    URL Configuration Master ID
                                </th>

                                <th style="width: 5%; text-align: center;min-width: 100px;">
                                    Client Name
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 100px;">
                                    Error Message
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Source URL Error
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Field Level Error
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 200px;">
                                    Total Received Records
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 150px;">
                                    Processed Records
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Error Records
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Created On
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="reviewCrawledDatalSearchList2?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 70px; padding-top: 70px;">
                                    <h6 class="text-center" style="color: red;" *ngIf="reviewCrawledDatalSearchList2?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of reviewCrawledDatalSearchList2;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td *ngIf="columnList2[0].checked" style="width: 10%; text-align:center;min-width: 100px;"
                                    class="ellipsis" title="{{data?.CrawledJSONID}}">
                                    {{data?.CrawledJSONID}}</td>
                                <td *ngIf="columnList2[1].checked" style="width: 150px; text-align:center;min-width: 150px;"
                                    class="ellipsis" title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}</td>
                                <td *ngIf="columnList2[2].checked" style="width:5%;min-width: 100px;text-align: center;" class="ellipsis"
                                    title=" {{data?.ClientName}}">
                                    {{data?.ClientName}}
                                </td>
                                <td *ngIf="columnList2[3].checked" style="width:5%;min-width: 100px;text-align: center;" class="ellipsis"
                                    title=" {{data?.ErrorMessage}}">
                                    {{data?.ErrorMessage}}
                                </td>
                                <td *ngIf="columnList2[4].checked" style="width:10%; text-align:center;min-width: 120px;" class="ellipsis"
                                    title="{{data?.SourceURLError}}">
                                    {{data?.SourceURLError}}
                                </td>
                                <td *ngIf="columnList2[5].checked" style="width:5%;min-width: 120px;text-align: center;" class="ellipsis"
                                    title=" {{data?.FieldLevelError}}">
                                    {{data?.FieldLevelError}}
                                </td>
                                <td *ngIf="columnList2[6].checked" style="width:5%;min-width: 150px;text-align: center;" class="ellipsis"
                                    title=" {{data?.TotalReceivedRecords}}">
                                    {{data?.TotalReceivedRecords}}
                                </td>
                                <td *ngIf="columnList2[7].checked" style="width:5%;min-width: 100px;text-align: center;" class="ellipsis"
                                    title=" {{data?.ProcessedRecords}}">
                                    {{data?.ProcessedRecords}}
                                </td>
                                <td *ngIf="columnList2[8].checked" style="width:5%;min-width: 120px;text-align: center;" class="ellipsis"
                                    title=" {{data?.ErrorRecords}}">
                                    {{data?.ErrorRecords}}
                                </td>
                                <td *ngIf="columnList2[9].checked" style="width:5%;min-width: 120px;text-align: center;" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY}}">{{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>
                            </tr>
                            <tr
                                *ngIf="reviewCrawledDatalSearchList2?.length<=4 && reviewCrawledDatalSearchList2?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Last 10 Days Process Records Status</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 10%; text-align: center;min-width: 130px;">
                                    Crawled JSON ID
                                </th>

                                <th style="width: 10%; text-align: center;min-width: 200px;">
                                    URL Configuration Master ID
                                </th>

                                <th style="width: 5%; text-align: center;min-width: 100px;">
                                    Client Name
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Error Message
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 150px;">
                                    Source URL Error
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Field Level Error
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 180px;">
                                    Total Received Records
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 150px;">
                                    Processed Records
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 120px;">
                                    Error Records
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 100px;">
                                    Created On
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 150px;">
                                    Crawled Data
                                </th>
                                <th style="width: 5%; text-align: center;min-width: 150px;">
                                    Processed Data
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="reviewCrawledDatalSearchList3?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 70px; padding-top: 70px;">
                                    <h6 class="text-center" style = "color : red;" *ngIf="reviewCrawledDatalSearchList3?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of reviewCrawledDatalSearchList3;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td *ngIf="columnList3[0].checked" style="width: 10%; text-align:center"
                                    class="ellipsis" title="{{data?.CrawledJSONID}}">
                                    {{data?.CrawledJSONID}}</td>
                                <td *ngIf="columnList3[1].checked" style="width: 10%; text-align:center"
                                    class="ellipsis" title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}</td>
                                <td *ngIf="columnList3[2].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.ClientName}}">
                                    {{data?.ClientName}}
                                </td>
                                <td *ngIf="columnList3[3].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.ErrorMessage}}">
                                    {{data?.ErrorMessage}}
                                </td>
                                <td *ngIf="columnList3[4].checked" style="width:10%; text-align:center" class="ellipsis"
                                    title="{{data?.SourceURLError}}">
                                    {{data?.SourceURLError}}
                                </td>
                                <td *ngIf="columnList3[5].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.FieldLevelError}}">
                                    {{data?.FieldLevelError}}
                                </td>
                                <td *ngIf="columnList3[6].checked" style="width:10%;text-align: center;" class="ellipsis"
                                    title=" {{data?.TotalReceivedRecords}}">
                                    {{data?.TotalReceivedRecords}}
                                </td>
                                <td *ngIf="columnList3[7].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.ProcessedRecords}}">
                                    {{data?.ProcessedRecords}}
                                </td>
                                <td *ngIf="columnList3[8].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title=" {{data?.ErrorRecords}}">
                                    {{data?.ErrorRecords}}
                                </td>
                                <td *ngIf="columnList3[9].checked" style="width:5%;text-align: center;" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY}}">{{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td *ngIf="columnList3[10].checked" style="width:10%;" class="ellipsis">
                                    <a (click)="downloadXml(data?.CrawledData,'CrawledData')" title="Download XML File"
                                        class="blue-link">
                                        Download Crawled Data
                                    </a>
                                </td>
                                <td *ngIf="columnList3[11].checked" style="width:10%;text-align: center;" class="ellipsis">
                                    <a (click)="downloadXml(data?.ProcessedData,'ProcessedData')" title="Download XML File"
                                        class="blue-link">
                                        Download Processed Data
                                    </a>
                                </td>
                            </tr>
                            <tr
                                *ngIf="reviewCrawledDatalSearchList3?.length<=4 && reviewCrawledDatalSearchList3?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- </perfect-scrollbar> -->

                </div>


            </div>

        </div>
    </div>
</main>
<app-loader [showLoader]="showLoader"></app-loader>
<notifier-container></notifier-container>